import React, { useEffect, createElement } from 'react';
import { Check, FileText, ArrowRight, Shield, Calendar } from 'lucide-react';
import { motion } from 'framer-motion';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function OfferSection() {
  // Load Meta Pixel script on mount
  useEffect(() => {
    if (window.fbq) return;
    const n = (window.fbq = function (...args: any[]) {
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
    }) as any;
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [] as any[];
    const t = document.createElement('script');
    t.async = true;
    t.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(t);
    window.fbq('init', '1214022534237592');
    window.fbq('track', 'PageView');
  }, []);
  const handleCtaClick = () => {
    if (window.fbq) {
      window.fbq('track', 'InitiateCheckout');
    }
  };
  return <div className="w-full" data-id="element-186">
      {/* What's Included (Light) */}
      <section className="py-12 md:py-20 px-4 bg-[#f5f0e8] text-[#0f1b2d]" data-id="element-187">
        <div className="max-w-4xl mx-auto" data-id="element-188">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-black text-center mb-8 md:mb-12" data-id="element-189">
            Qué incluye exactamente
          </motion.h2>

          <div className="grid md:grid-cols-2 gap-8 md:gap-12" data-id="element-190">
            {/* List */}
            <motion.ul initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="space-y-3 md:space-y-4" data-id="element-191">
              {['cómo elegir un micro-servicio que se vende', 'lista de "problemas que pagan" vs "problemas trampa"', 'plantilla de Oferta 1-página (copiar/pegar)', 'precios y paquetes 49/69/99', 'mensajes exactos para WhatsApp', 'sistema de entrega en 60–90 min', 'plan de 14 días con 5h/semana'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-192">
                  <Check className="w-5 h-5 text-[#25D366] mt-1 shrink-0" data-id="element-193" />
                  <span className="font-medium" data-id="element-194">{item}</span>
                </li>)}
            </motion.ul>

            {/* Templates Box */}
            <motion.div initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="bg-white p-6 md:p-8 rounded-2xl shadow-lg border border-gray-100" data-id="element-195">
              <h3 className="text-xl font-bold mb-4 md:mb-6 flex items-center gap-2" data-id="element-196">
                <FileText className="w-6 h-6 text-[#25D366]" data-id="element-197" />
                Plantillas incluidas
              </h3>
              <ul className="space-y-3 md:space-y-4" data-id="element-198">
                {['Oferta 1-página (rellenable)', 'Checklist "primera venta"', 'Guion para pedir testimonio'].map((item, i) => <li key={i} className="flex items-center gap-3 p-3 bg-gray-50 rounded-lg" data-id="element-199">
                    <div className="w-2 h-2 rounded-full bg-[#25D366]" data-id="element-200"></div>
                    <span className="text-gray-700" data-id="element-201">{item}</span>
                  </li>)}
              </ul>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Results (Light) */}
      <section className="py-10 md:py-16 px-4 bg-[#f5f0e8] border-t border-gray-200" data-id="element-202">
        <div className="max-w-3xl mx-auto text-center" data-id="element-203">
          <h2 className="text-2xl md:text-3xl font-bold mb-6 md:mb-10" data-id="element-204">
            Qué resultados esperar (realistas)
          </h2>

          <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8 mb-6 md:mb-8" data-id="element-205">
            <div className="bg-white p-4 md:p-6 rounded-xl shadow-sm w-full md:w-auto flex-1" data-id="element-206">
              <div className="text-[#25D366] font-bold mb-2 flex justify-center" data-id="element-207">
                <Calendar className="w-6 h-6" data-id="element-208" />
              </div>
              <div className="font-black text-xl mb-1" data-id="element-209">Semana 1</div>
              <div className="text-gray-600" data-id="element-210">
                oferta lista + 10 conversaciones
              </div>
            </div>
            <ArrowRight className="hidden md:block text-gray-300 w-8 h-8" data-id="element-211" />
            <ArrowRight className="md:hidden text-gray-300 w-6 h-6 rotate-90" data-id="element-212" />
            <div className="bg-white p-4 md:p-6 rounded-xl shadow-sm w-full md:w-auto flex-1 border-2 border-[#25D366]/20" data-id="element-213">
              <div className="text-[#25D366] font-bold mb-2 flex justify-center" data-id="element-214">
                <Calendar className="w-6 h-6" data-id="element-215" />
              </div>
              <div className="font-black text-xl mb-1" data-id="element-216">Semana 2</div>
              <div className="text-gray-600" data-id="element-217">
                1–3 ventas si repites y ajustas
              </div>
            </div>
          </div>

          <p className="text-gray-500 italic" data-id="element-218">
            Esto no es magia: es matemáticas de conversaciones.
          </p>
        </div>
      </section>

      {/* Income visual break */}
      <section className="relative bg-[#f5f0e8]" data-id="element-219">
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="max-w-5xl mx-auto px-4" data-id="element-220">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl border border-gray-200" data-id="element-221">
            <img src="https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=1200&q=80&auto=format&fit=crop" alt="Persona realizando un pago móvil, representando ingresos por WhatsApp" className="w-full h-48 md:h-72 object-cover" data-id="element-222" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0f1b2d] via-[#0f1b2d]/40 to-transparent flex items-end p-6 md:p-10" data-id="element-223">
              <p className="text-[#f5f0e8] font-bold text-lg md:text-2xl max-w-md" data-id="element-224">
                Tu móvil ya es tu herramienta. Solo falta el sistema.
              </p>
            </div>
          </div>
        </motion.div>
        <div className="h-8 md:h-12" data-id="element-225"></div>
      </section>

      {/* Pricing & Guarantee (Dark) */}

      {/* Final CTA (Darker) */}
      <section id="final-cta" className="py-14 md:py-24 px-4 bg-[#0a121f] text-center text-[#f5f0e8]" data-id="element-226">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto" data-id="element-227">
          <h2 className="text-2xl md:text-4xl font-bold mb-4 md:mb-6" data-id="element-228">
            Si quieres un extra sin cambiar de trabajo y sin montarte una
            película:
          </h2>
          <p className="text-lg md:text-2xl text-[#f5f0e8]/80 mb-8 md:mb-12" data-id="element-229">
            Consigue{' '}
            <strong className="text-[#25D366]" data-id="element-230">
              "100€ Extra/semana por WhatsApp"
            </strong>{' '}
            y hoy mismo sales con oferta + mensajes listos.
          </p>

          {/* Highlighted CTA */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="relative" data-id="element-231">
            {/* Pulsing glow ring */}
            <div className="absolute inset-0 flex items-center justify-center pointer-events-none" data-id="element-232">
              <div className="w-72 h-72 md:w-96 md:h-96 rounded-full bg-[#25D366]/10 animate-ping" style={{
              animationDuration: '3s'
            }} data-id="element-233"></div>
            </div>

            <div className="relative z-10 inline-flex flex-col items-center gap-5" data-id="element-234">
              {/* Price block */}
              <div className="flex items-baseline gap-3 mb-2" data-id="element-235">
                <span className="line-through text-[#f5f0e8]/30 text-2xl md:text-3xl font-bold" data-id="element-236">
                  29€
                </span>
                <span className="text-5xl md:text-7xl font-black text-[#25D366] tracking-tight" data-id="element-237">
                  6,36€
                </span>
              </div>
              <div className="inline-block bg-red-500 text-white text-sm font-bold px-4 py-1.5 rounded-full mb-2 animate-pulse" data-id="element-238">
                🔥 78% de descuento — oferta limitada
              </div>

              {/* Main CTA button */}
              <a href="https://plenava.com/cart/52337462804827id1:1" target="_blank" rel="noopener noreferrer" onClick={handleCtaClick} className="group relative w-full md:w-auto bg-[#25D366] hover:bg-[#20bd5a] text-[#0f1b2d] font-black text-xl md:text-2xl py-5 md:py-6 px-12 md:px-16 rounded-2xl shadow-[0_0_40px_rgba(37,211,102,0.4)] hover:shadow-[0_0_60px_rgba(37,211,102,0.6)] transition-all duration-300 transform hover:scale-105 flex items-center justify-center gap-3" data-id="element-239">
                Quiero empezar hoy YA
              </a>

              {/* Trust line */}
              <div className="flex items-center justify-center gap-2 text-sm text-[#f5f0e8]/50 mt-2" data-id="element-240">
                <Shield className="w-4 h-4" data-id="element-241" />
                <span data-id="element-242">Pago seguro · Acceso inmediato · Garantía 14 días</span>
              </div>
            </div>
          </motion.div>
        </motion.div>
      </section>

      {/* Footer */}
      <footer className="py-8 md:py-12 px-4 bg-[#060d17] text-[#f5f0e8]/50 text-sm" data-id="element-243">
        <div className="max-w-4xl mx-auto" data-id="element-244">
          <div className="flex flex-col md:flex-row justify-between items-start gap-10 mb-10" data-id="element-245">
            {/* Brand */}
            <div className="flex-1" data-id="element-246">
              <div className="text-[#f5f0e8] font-bold text-lg mb-2" data-id="element-247">
                Plenava.com
              </div>
              <p className="text-xs leading-relaxed max-w-xs" data-id="element-248">
                Productos digitales para generar ingresos extra con sistemas
                simples y repetibles.
              </p>
              <p className="mt-3 text-xs" data-id="element-249">
                Contacto:{' '}
                <a href="mailto:plenavaweb@gmail.com" className="text-[#25D366] hover:underline" data-id="element-250">
                  plenavaweb@gmail.com
                </a>
              </p>
            </div>

            {/* Legal Links */}
            <div className="flex-1" data-id="element-251">
              <div className="text-[#f5f0e8]/70 font-bold text-xs uppercase tracking-wider mb-4" data-id="element-252">
                Legal
              </div>
              <ul className="space-y-2" data-id="element-253">
                <li data-id="element-254">
                  <button onClick={() => document.getElementById('privacy-modal')?.classList.toggle('hidden')} className="hover:text-[#25D366] transition-colors" data-id="element-255">
                    Política de Privacidad
                  </button>
                </li>
                <li data-id="element-256">
                  <button onClick={() => document.getElementById('terms-modal')?.classList.toggle('hidden')} className="hover:text-[#25D366] transition-colors" data-id="element-257">
                    Términos y Condiciones
                  </button>
                </li>
                <li data-id="element-258">
                  <button onClick={() => document.getElementById('refund-modal')?.classList.toggle('hidden')} className="hover:text-[#25D366] transition-colors" data-id="element-259">
                    Política de Reembolso
                  </button>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-[#f5f0e8]/10 pt-6 text-center text-xs text-[#f5f0e8]/30" data-id="element-260">
            © {new Date().getFullYear()} Plenava.com — Todos los derechos
            reservados.
          </div>
        </div>

        {/* Privacy Modal */}
        <div id="privacy-modal" className="hidden fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4" onClick={e => {
        if (e.target === e.currentTarget) e.currentTarget.classList.add('hidden');
      }} data-id="element-261">
          <div className="bg-[#f5f0e8] text-[#0f1b2d] rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto p-8" data-id="element-262">
            <div className="flex justify-between items-center mb-6" data-id="element-263">
              <h3 className="text-2xl font-black" data-id="element-264">Política de Privacidad</h3>
              <button onClick={() => document.getElementById('privacy-modal')?.classList.add('hidden')} className="text-gray-400 hover:text-gray-600 text-2xl" data-id="element-265">
                &times;
              </button>
            </div>
            <div className="space-y-4 text-sm text-gray-700 leading-relaxed" data-id="element-266">
              <p data-id="element-267">
                <strong data-id="element-268">Responsable:</strong> Plenava.com — plenavaweb@gmail.com
              </p>
              <p data-id="element-269">
                <strong data-id="element-270">Datos que recogemos:</strong> Nombre, email y datos de
                pago necesarios para procesar tu compra. No almacenamos datos de
                tarjeta; el pago se gestiona a través de pasarelas seguras de
                terceros.
              </p>
              <p data-id="element-271">
                <strong data-id="element-272">Finalidad:</strong> Gestionar tu compra, enviarte el
                producto digital adquirido y comunicaciones relacionadas con tu
                pedido.
              </p>
              <p data-id="element-273">
                <strong data-id="element-274">Base legal:</strong> Ejecución del contrato de
                compraventa y consentimiento del usuario.
              </p>
              <p data-id="element-275">
                <strong data-id="element-276">Conservación:</strong> Tus datos se conservarán mientras
                sea necesario para la prestación del servicio y el cumplimiento
                de obligaciones legales.
              </p>
              <p data-id="element-277">
                <strong data-id="element-278">Derechos:</strong> Puedes ejercer tus derechos de
                acceso, rectificación, supresión, portabilidad y oposición
                escribiendo a plenavaweb@gmail.com.
              </p>
              <p data-id="element-279">
                <strong data-id="element-280">Cookies:</strong> Este sitio puede utilizar cookies
                técnicas y analíticas. Al navegar, aceptas su uso.
              </p>
            </div>
          </div>
        </div>

        {/* Terms Modal */}
        <div id="terms-modal" className="hidden fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4" onClick={e => {
        if (e.target === e.currentTarget) e.currentTarget.classList.add('hidden');
      }} data-id="element-281">
          <div className="bg-[#f5f0e8] text-[#0f1b2d] rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto p-8" data-id="element-282">
            <div className="flex justify-between items-center mb-6" data-id="element-283">
              <h3 className="text-2xl font-black" data-id="element-284">Términos y Condiciones</h3>
              <button onClick={() => document.getElementById('terms-modal')?.classList.add('hidden')} className="text-gray-400 hover:text-gray-600 text-2xl" data-id="element-285">
                &times;
              </button>
            </div>
            <div className="space-y-4 text-sm text-gray-700 leading-relaxed" data-id="element-286">
              <p data-id="element-287">
                <strong data-id="element-288">1. Objeto:</strong> Estos términos regulan la compra y
                descarga del producto digital "100€ Extra/semana por WhatsApp"
                ofrecido por Plenava.com.
              </p>
              <p data-id="element-289">
                <strong data-id="element-290">2. Producto digital:</strong> Al completar la compra
                recibirás acceso inmediato al contenido digital (ebook/guía
                descargable). El producto se entrega en formato digital y no
                incluye soporte físico.
              </p>
              <p data-id="element-291">
                <strong data-id="element-292">3. Licencia de uso:</strong> Adquieres una licencia
                personal, intransferible y no exclusiva para uso propio. Queda
                prohibida la redistribución, reventa, copia o cesión del
                contenido a terceros.
              </p>
              <p data-id="element-293">
                <strong data-id="element-294">4. Precio y pago:</strong> El precio indicado en la
                página de venta incluye impuestos aplicables. El pago se realiza
                a través de pasarelas seguras de terceros.
              </p>
              <p data-id="element-295">
                <strong data-id="element-296">5. Entrega:</strong> El producto se entrega de forma
                inmediata tras la confirmación del pago, mediante enlace de
                descarga o acceso por email.
              </p>
              <p data-id="element-297">
                <strong data-id="element-298">6. Propiedad intelectual:</strong> Todo el contenido del
                producto es propiedad de Plenava.com y está protegido por las
                leyes de propiedad intelectual.
              </p>
              <p data-id="element-299">
                <strong data-id="element-300">7. Limitación de responsabilidad:</strong> Los
                resultados dependen de la aplicación individual. Plenava.com no
                garantiza resultados económicos específicos.
              </p>
              <p data-id="element-301">
                <strong data-id="element-302">8. Contacto:</strong> Para cualquier consulta:
                plenavaweb@gmail.com
              </p>
            </div>
          </div>
        </div>

        {/* Refund Modal */}
        <div id="refund-modal" className="hidden fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4" onClick={e => {
        if (e.target === e.currentTarget) e.currentTarget.classList.add('hidden');
      }} data-id="element-303">
          <div className="bg-[#f5f0e8] text-[#0f1b2d] rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto p-8" data-id="element-304">
            <div className="flex justify-between items-center mb-6" data-id="element-305">
              <h3 className="text-2xl font-black" data-id="element-306">Política de Reembolso</h3>
              <button onClick={() => document.getElementById('refund-modal')?.classList.add('hidden')} className="text-gray-400 hover:text-gray-600 text-2xl" data-id="element-307">
                &times;
              </button>
            </div>
            <div className="space-y-4 text-sm text-gray-700 leading-relaxed" data-id="element-308">
              <p data-id="element-309">
                Al tratarse de un producto digital de descarga inmediata, de
                acuerdo con el artículo 103 del Real Decreto Legislativo 1/2007,
                el derecho de desistimiento no aplica una vez iniciada la
                descarga o acceso al contenido.
              </p>
              <p data-id="element-310">
                <strong data-id="element-311">Garantía de satisfacción:</strong> No obstante, si
                dentro de los primeros 14 días desde la compra consideras que el
                producto no se ajusta a lo descrito, puedes escribirnos a
                plenavaweb@gmail.com y estudiaremos tu caso de forma individual.
              </p>
              <p data-id="element-312">
                <strong data-id="element-313">Proceso:</strong> Envía un email a plenavaweb@gmail.com
                indicando tu nombre, email de compra y motivo. Responderemos en
                un plazo máximo de 48 horas laborables.
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>;
}